import { PIPELINE_TOOL_NAMES } from '@kw/quokka-ui';
import { OrgPolicyResults } from '../types/ApplicationDetailsType';

export const getReviewActionOptions = (hasPermission: boolean, setIsOpenReviewModal: (isOpen: boolean) => void) =>
  hasPermission
    ? [
        {
          label: 'Review Rule',
          value: 'review_rule',
          onClick: () => setIsOpenReviewModal(true),
        },
      ]
    : [];

export const getCategoryFromRuleId = ruleId => {
  const parts = ruleId.split('/');
  if (parts[0] === 'profile' || parts[0] === 'audit') {
    return parts[1] || parts[0];
  }
  return parts[0];
};

export const isBehavioral = ruleSummary =>
  (ruleSummary.rule?.tool === PIPELINE_TOOL_NAMES.pattern ||
    ruleSummary.rule?.tool === `${PIPELINE_TOOL_NAMES.pattern}-ios` ||
    ruleSummary.rule?.tool === PIPELINE_TOOL_NAMES.permission) &&
  ruleSummary.rule?.id?.startsWith('profile');

export const buildCustomRulesObject = ({ possibleForeignConnectionRule, highRiskCountriesConnectionRule }) => {
  const rules = {};

  if (possibleForeignConnectionRule?.foreignConnections?.length > 0) {
    rules['possible-foreign-connection'] = {
      evidence: possibleForeignConnectionRule?.foreignConnections,
      metadata: possibleForeignConnectionRule?.foreignConnectionRuleMetadata,
    };
  }

  if (highRiskCountriesConnectionRule?.highRiskCountryConnections?.length > 0) {
    rules['highrisk-country-connection'] = {
      evidence: highRiskCountriesConnectionRule?.highRiskCountryConnections,
      metadata: highRiskCountriesConnectionRule?.highRiskCountryConnectionRuleMetadata,
    };
  }

  return rules;
};

const appendPolicyNameForRule = (map: Record<string, string[]>, ruleId: string, policyName: string) => {
  const policyNames = map[ruleId] ?? [];
  if (!policyNames.includes(policyName)) {
    policyNames.push(policyName);
  }
  map[ruleId] = policyNames;
};

const addViolationToPolicyMap = (map: Record<string, string[]>, violation: OrgPolicyResults) => {
  for (const rule of violation.associatedRules) {
    for (const ruleIds of Object.values(rule.appIorResultsMap)) {
      if (!ruleIds) continue;
      for (const ruleId of ruleIds) {
        if (!ruleId) continue;
        appendPolicyNameForRule(map, ruleId, violation.policyName);
      }
    }
  }
};

// returns a map of rule id to violated policy names (multiple policies can reference the same rule)
export const buildPolicyViolationMap = (policyViolations: OrgPolicyResults[] = []) => {
  const map: Record<string, string[]> = {};
  for (const violation of policyViolations) {
    if (!violation.didTrigger) continue;
    addViolationToPolicyMap(map, violation);
  }
  return map;
};
